<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container main_bg">
      <i-card-vertical headerTitle="할인 관리" device="web" :IsUseSearchRequirement="true">
        <template v-slot:SearchRequirement>
          <v-row no-gutters>
            <v-col class="d-flex justify-space-between align-center">
              <v-switch v-model="discountUseYn">
                <template v-slot:label>
                  <span style="margin-left: 5px;">{{ discountUseYn ? "사용" : "미사용" }}</span>
                </template>
              </v-switch>
            </v-col>
          </v-row>
        </template>

        <template v-slot:body>
          <DxDataGrid
            id="discountDataGrid"
            class="layout-col-height00"
            :ref="dxDataGridRef"
            :data-source="gridMain"
            :remote-operations="false"
            :hover-state-enabled="true"
            :allow-column-reordering="true"
            :allow-column-resizing="true"
            :row-alternation-enabled="true"
            :column-auto-width="true"
            :show-borders="true"
            :show-row-lines="true"
            :selection="{ mode: 'single' }"
            key-expr="id"
            :focused-row-enabled="true"
            @editing-start="onEditingStart"
            @editor-preparing="onEditorPreparing"
          >
            <DxEditing :allow-updating="true" mode="batch" :select-text-on-edit-start="true" />
            <DxSelection select-all-mode="allPages" show-check-boxes-mode="always" mode="multiple" />
            <DxColumn
              data-field="discountCd"
              data-type="string"
              width="180px"
              alignment="center"
              caption="할인 코드"
              :allow-editing="false"
            />

            <DxColumn
              css-class="devest-grid-header-require"
              data-field="div"
              data-type="string"
              width="100px"
              alignment="center"
              caption="항목 구분"
            >
              <DxLookup :data-source="discountDiv" display-expr="minorNm" value-expr="minorCd" />
            </DxColumn>

            <DxColumn
              css-class="devest-grid-header-require"
              data-field="method"
              data-type="string"
              width="100px"
              alignment="center"
              caption="할인 구분"
            >
              <DxLookup :data-source="discountMethod" display-expr="minorNm" value-expr="minorCd" />
            </DxColumn>

            <DxColumn
              css-class="devest-grid-header-require"
              data-field="feeCd"
              data-type="string"
              alignment="left"
              width="300px"
              caption="적용 요금제"
              :showEditorAlways="true"
              edit-cell-template="applyFeeList"
            />

            <DxColumn
              css-class="devest-grid-header-require"
              data-field="discountAmount"
              width="110px"
              data-type="int"
              alignment="center"
              caption="할인액"
              cell-template="calcKorWon"
            />

            <DxColumn
              css-class="devest-grid-header-require"
              data-field="discountPercent"
              width="110px"
              data-type="int"
              alignment="center"
              caption="할인율"
              cell-template="calcPercent"
            />

            <DxColumn
              css-class="devest-grid-header-require"
              data-field="discountDtS"
              data-type="string"
              width="120px"
              caption="사용시작일"
              alignment="center"
              :allow-editing="true"
              edit-cell-template="dateEditor"
            />

            <DxColumn
              css-class="devest-grid-header-require"
              data-field="discountDtE"
              data-type="string"
              width="120px"
              alignment="center"
              caption="사용종료일"
              :allow-editing="true"
              edit-cell-template="dateEditor"
            />
            <DxColumn
              data-field="useYn"
              data-type="boolean"
              width="90px"
              alignment="center"
              caption="사용"
              :allow-editing="true"
              edit-cell-template="checkBoxEditor"
            />
            <DxColumn
              data-field="count"
              data-type="int"
              width="90px"
              alignment="center"
              caption="개수"
              :allow-editing="true"
            />
            <DxColumn
              data-field="remark"
              data-type="string"
              width="200px"
              alignment="center"
              caption="비고"
              :allow-editing="true"
            />
            <template #calcKorWon="{ data: cellInfo }">
              <span>{{calcKorWon(cellInfo.value) + '원'}}</span>
            </template>
            <template #calcPercent="{ data: cellInfo }">
              <span>{{calcPercent(cellInfo.value) + '%'}}</span>
            </template>

            <template #checkBoxEditor="{ data: cellInfo }">
              <DxCheckBox
                :value="cellInfo.value == 'Y' ? true : false"
                :onValueChanged="value => onCheckValueChanged(value, cellInfo)"
              />
            </template>
            <template #dateEditor="{ data: cellInfo}">
              <div>
                <DxDateBox
                  :value="cellInfo.value"
                  type="date"
                  picker-type="calendar"
                  display-format="yyyy.MM.dd"
                  :use-mask-behavior="true"
                  @value-changed="onDateValueChanged($event, cellInfo)"
                />
              </div>
            </template>
            <template #applyFeeList="{ data: cellInfo }">
              <v-autocomplete
                item-text="feeName"
                item-value="feeCd"
                :menu-props="{ offsetY: false }"
                :items="feeList"
                rounded
                chips
                multiple
                dense
                density
                :value="cellInfo.value !== null ? cellInfo.value.split(',') : ''"
                @change="onApplyFeeValueChanged($event, cellInfo)"
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip
                    v-if="index < 2"
                    @click.close="item = false"
                    style="overflow: initial;"
                  >{{ item.feeName }}</v-chip>
                  <span v-if="index === 2" class="text-grey text-caption align-self-center">(+α)</span>
                </template>
              </v-autocomplete>
            </template>
          </DxDataGrid>
        </template>
      </i-card-vertical>
      <i-card-right
        headerTitle
        :useBtnList="buttonUseList"
        @btnSearch="btnSearch(true)"
        @btnAdd="btnAdd()"
        @btnSave="btnSave()"
      ></i-card-right>
    </v-sheet>
  </v-container>
</template>
  
<script>
import iCardVertical from '@/components/common/iCardVertical.vue'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'
import baseview from '@/views/base/baseview.vue'
import DxDateBox from 'devextreme-vue/date-box'
// import { getFeeList, saveFeeData } from '@/api/feeManage/feeManage.js'
import { getCurrentDate, getPreMonth } from '@/utils/common.js'

import { getCommonCode } from '@/api/common/commonApi'
import { getFeeList } from '@/api/feeManage/feeManage.js'
import { getDiscountList, saveDiscountData } from '@/api/feeManage/discountManage.js'

export default {
  mixins: [baseview, BaseDataGrid],
  name: 'discountManage',
  components: {
    'i-card-vertical': iCardVertical,
    DxDateBox
  },
  data() {
    return {
      dxDataGridRef: 'discountGridRef',
      gridMain: [],
      allowEditingColList: [],
      discountUseYn: true,
      buttonUseList: [
        'btnSearch', //조회
        'btnAdd', //추가
        'btnSave' // 저장
      ],
      discountMethod: [], // 항목 구분
      discountDiv: [] // 할인 구분
    }
  },
  activated() {},
  watch: {
    discountUseYn() {
      this.btnSearch(true)
    }
  },
  computed: {},
  beforeMount() {},
  created() {
    // 항목 구분 조회
    getCommonCode('DC001').then(res => {
      if (res.success) this.discountDiv = res.list
    })
    // 할인 구분
    getCommonCode('DC002').then(res => {
      if (res.success) this.discountMethod = res.list
    })
    let params = {
      clntId: this.getClntId(),
      useYn: 'Y'
    }
    getFeeList(params)
      .then(res => {
        if (res.success) {
          this.feeList = res.list
        }
      })
      .catch(err => {})
      .finally(() => {})
  },
  mounted() {
    this.btnSearch(true)
  },
  methods: {
    //------------------------------------------
    //  버튼 이벤트
    //------------------------------------------
    btnSearch(notify = false) {
      let params = {
        clntId: this.getClntId(),
        useYn: this.discountUseYn ? 'Y' : 'N'
      }
      this.openLoading()
      getDiscountList(params, notify)
        .then(res => {
          if (res.success) {
            this.gridMain = res.list
            if (res.list.length > 0) this.GetDataGrid(this.dxDataGridRef).clearSelection()
          }
        })
        .catch(err => {
          this.endLoading()
        })
        .finally(() => {
          this.endLoading()
        })
    },
    btnAdd() {
      let newRow = {
        id: (this.gridMain.length + '_' + new Date().getSeconds() + new Date().getMilliseconds()).toString(),
        discountCd: '',
        div: '',
        method: '',
        feeCd: '',
        discountAmount: '0',
        discountPercent: '0',
        discountDtS: getCurrentDate().replaceAll('-', '.'),
        discountDtE: getPreMonth(-3).replaceAll('-', '.'),
        count: 0,
        useYn: 'Y',
        remark: '',
        __created__: true
      }
      this.GetDataGrid(this.dxDataGridRef).newRow(newRow)
      this.GetDataGrid(this.dxDataGridRef).selectRows(newRow.id, true)
    },
    btnSave() {
      this.GetDataGrid(this.dxDataGridRef)
        .getSelectedRowsData()
        .then(selectedRows => {
          if (selectedRows.length === 0) {
            this.vToastify(this.$t('selectionData'), 'info')
            return
          }
          console.log('@@@@@@ saveData ==> ', selectedRows)
          this.GetDataGrid(this.dxDataGridRef).saveEditData()
          let valid = selectedRows.findIndex(el => !el.div || !el.method || !el.feeCd || !el.discountDtS || !el.discountDtE)
          if (valid >= 0) {
            this.vToastify(this.$t('필수항목 입력하세요.'), 'info')
            return
          }
          let countValid = selectedRows.findIndex(el => isNaN(el.count) || el.count < 0)
          if (countValid >= 0) {
            this.vToastify(this.$t('순서는 숫자만 입력 가능합니다.'), 'info')
            return
          }
          this.vToastifyPrompt(
            this.$t('doSaveData'),
            'info',
            async () => {
              selectedRows.forEach(row => {
                if (row.feeCd != '' && row.feeCd != undefined) {
                  row.feeCdList = row.feeCd.split(',')
                  if (row.feeCdList[0] == '') row.feeCdList = row.feeCdList.splice(1)
                }
              })
              // this.GetDataGrid(this.dxDataGridRef).beginUpdate()
              this.GetDataGrid(this.dxDataGridRef).saveEditData()
              this.openLoading('')
              try {
                saveDiscountData(selectedRows, true).then(res => {
                  //
                  this.btnSearch()
                })
              } catch (error) {
                this.endLoading()
              } finally {
                this.endLoading()
              }
            },
            null,
            true
          )
        })
    },
    //------------------------------------------
    //  etc 이벤트
    //------------------------------------------
    calcKorWon(value) {
      const numberValue = parseFloat(value.replace(/,/g, ''))
      if (!isNaN(numberValue)) {
        return numberValue.toLocaleString('ko-KR')
      } else return 0
    },
    calcPercent(value) {
      if (value < 0 || value > 100) {
        return 0
      } else return value ? parseInt(value) : 0
    },
    onEditingStart(e) {
      // if (!e.data.__created__ && !this.allowEditingColList.includes(e.column.dataField)) {
      //   e.cancel = true
      // }
      // console.log('## e', e)
      if (!e.data.method && (e.column.dataField === 'discountAmount' || e.column.dataField === 'discountPercent')) {
        this.vSnackbar(this.$t('할인 구분을 선택하세요.'), 'warn', 3000)
        e.cancel = true
      }
    },
    onEditorPreparing(e) {
      // onCellValueChanged 를 사용하기 위함
      if (e.parentType == 'dataRow') {
        var valueChanged = this.onCellValueChanged
        e.editorOptions.onValueChanged = args => {
          if (e.index > -1) valueChanged(args.value, e)
        }
        if (e.row.data.method === '00001') {
          // 할인 구분 '정액 할인' 일 때 할인율 수정 불가
          e.cancel = false
          if (e.name === 'discountPercent') {
            e.editorOptions.readOnly = true
          }
        } else if (e.row.data.method === '00002') {
          // 할인 구분 '정률 할인' 일 때 할인액 수정 불가
          e.cancel = false
          if (e.name === 'discountAmount') {
            e.editorOptions.readOnly = true
          }
        }
      }
      // if (e.parentType === 'dataRow' && !e.row.data.__created__ && e.column) {
      //   if (!this.allowEditingColList.includes(e.column.dataField)) {
      //     e.editorOptions.readOnly = true
      //   }
      // }
    },
    onCellValueChanged(value, cellInfo) {
      if (cellInfo.dataField === 'discountAmount') {
        // 특수문자 제거
        value = value.replace(/[^\w\s]/gi, '')
      } else if (cellInfo.dataField === 'discountPercent') {
        value = value.replace(/[^\w\s]/gi, '')
        if (value < 0 || value > 100) {
          this.vSnackbar(this.$t('할인율 범위를 초과하였습니다.'), 'warn', 3000)
          value = 0
        }
      }
      // if (!cellInfo.row.data.__created__) {
      // this.vSnackbar(this.$t('기존 데이터일 경우 사용, 순서, 요금제 설명, 비고 항목만 수정이 가능합니다.'), 'warn', 3000)
      // return
      // }

      cellInfo.setValue(value)
      this.GetDataGrid(this.dxDataGridRef).selectRows(cellInfo.row.key, true)
      cellInfo.component.updateDimensions()
      // this.GetDataGrid(this.dxDataGridRef).saveEditData()
    },
    onCheckValueChanged(value, cellInfo) {
      cellInfo.setValue(cellInfo.value === 'Y' ? 'N' : 'Y')
      this.GetDataGrid(this.dxDataGridRef).selectRows(cellInfo.row.key, true)
      cellInfo.component.updateDimensions()
      // this.GetDataGrid(this.dxDataGridRef).saveEditData()
    },
    onDateValueChanged(event, cellInfo) {
      //날짜 세팅
      const date = new Date(event.value)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const dateFormat = `${year}.${month}.${day}`

      //그리드 삽입
      const cell = this.gridMain[cellInfo.rowIndex]
      cell[cellInfo.column.dataField] = dateFormat
      cellInfo.setValue(dateFormat)
      this.$refs[this.dxDataGridRef].instance.selectRows(cellInfo.row.key, true)
    },
    onApplyFeeValueChanged(value, cellInfo) {
      let val = value.sort()
      cellInfo.setValue(val.toString())
      this.GetDataGrid(this.dxDataGridRef).selectRows(cellInfo.row.key, true)
      cellInfo.component.updateDimensions()
    }
  }
}
</script>
  
  <style lang="scss">
.v-select--chips > .v-input__control > .v-input__slot > .v-select__slot > .v-select__selections {
  overflow: scroll;
  flex-wrap: nowrap;
}
.v-chip {
  overflow: initial;
}
</style>
  